import {
  Box,
  Flex,
  Text,
  Button,
  FormControl,
  Input,
  TabList,
  Tab,
} from "@chakra-ui/react";
import { chakra } from "@chakra-ui/react";

export const StyledContainer = chakra(Box, {
  baseStyle: {
    bg: "white",
    color: "black",
    minH: "100%",
    w: "94vw",
  },
});

export const StyledTabsContainer = chakra(Box, {
  baseStyle: {
    w: "full",
    mb:'auto'
  },
});

export const StyledTabList = chakra(TabList, {
  baseStyle: {

    display: "flex",
    borderBottom: "1px solid",
    borderColor: "gray.200",
  },
});

export const StyledTab = chakra(Tab, {
  baseStyle: {
    _selected: {
      bg: "blue.100",
      color: "blue.500",
      borderRadius: "8px",
      padding: "16px",
    },
    color: "gray.500",
    // Set height
    // Set padding
  },
});

export const StyledProfileContainer = chakra(Box, {
  baseStyle: {
    w: "full",
    maxW: "800px",
    bg: "white",
    p: 6,
    rounded: "md",
  },
});

export const StyledSectionTitle = chakra(Text, {
  baseStyle: {
    fontSize: "lg",
    fontWeight: "bold",
    mb: 4,
  },
});

export const StyledSectionDescription = chakra(Text, {
  baseStyle: {
    mb: 6,
    color: "gray.500",
    fontWeight: "400",
  },
});

export const StyledAvatarBox = chakra(Box, {
  baseStyle: {
    mb: 6,
    p: 4,
    bg: "white",
    border: "1px",
    borderColor: "gray.100",

    rounded: "md",
  },
});

export const StyledAvatarTitle = chakra(Text, {
  baseStyle: {
    fontSize: "md",
    fontWeight: "bold",
    mb: 4,
  },
});

export const StyledAvatarContainer = chakra(Flex, {
  baseStyle: {
    direction: "column",
    align: "center",
    mb: 4,
    gap: 4,
  },
});

export const StyledUserInfoBox = chakra(Box, {
  baseStyle: {
    p: 4,
    bg: "white",
    rounded: "md",
    border: "1px",
    borderColor: "gray.100",
  },
});

export const StyledFormControl = chakra(FormControl, {
  baseStyle: {
    mb: 4,
  },
});

export const StyledInput = chakra(Input, {
  baseStyle: {
    bg: "white",
    borderColor: "gray.300",
    _hover: { borderColor: "gray.400" },
    _focus: { borderColor: "gray.400" },
  },
});

export const StyledSubmitButton = chakra(Button, {
  baseStyle: {
    colorScheme: "blue",
  },
});

export const StyledButton = chakra(Button, {
  baseStyle: {
    bg: "white",
    borderRadius: "8px",
    border: "1px solid",
    padding: "12px",
    display: "flex",
    color: "#1782FF",
    alignItems: "center",
    justifyContent: "center",
    size: "sm",
    marginRight: "8px",
  },
});
export const StyledDeleteButton = chakra(Button, {
  baseStyle: {
    borderRadius: "8px",
    border: "1px solid",
    padding: "8px",
    gap: "2px",
    bg: "white",
    color: "red",
    size: "xs",
  },
});

export const StyledUserInfoHeader = chakra(Flex, {
  baseStyle: {
    justifyContent: "space-between",
    alignItems: "center",
    mb: 4,
  },
});
